export default function() {
    return {
        setting: {},
        success: false,
        customToolbar: [["bold", "italic", "underline"], [ { size: [ 'small', false, 'large' ]}], [{ list: "ordered" }, { list: "bullet" }], ["image"]],
        errors: {
            value: null
        }
    }
}
